<script>import { trackComponent } from "@sentry/svelte";
trackComponent({ "trackInit": true, "trackUpdates": true, "componentName": "InputEntity" });
import { InputText } from "../../../../inputs/index.js";
import { ENTITIES } from "./config.js";
export let value;
export let isDisabled = false;
export let isReadonly = false;
export let isRequired = false;
export let countryCode;
const getHint = (countryCode2) => {
    if (countryCode2 === void 0) {
        return "";
    }
    const LOCALIZED_ENTITIES = ENTITIES[countryCode2];
    if (!Array.isArray(LOCALIZED_ENTITIES)) {
        return "";
    }
    return `${LOCALIZED_ENTITIES.slice(0, 3).join(", ")} \u2026`;
};
$: hint = getHint(countryCode);
</script>

<InputText
    bind:value
    placeholder = 'resource.organization.properties.entity.placeholder'
    label = 'resource.organization.properties.entity.label'
    name = 'organization.entity'
    { hint }
    { isDisabled }
    { isReadonly }
    { isRequired }
/>